
let context = null;

export const init = (ctx) => {
  context = ctx
}


export const showSuccess = (msg) => {
  context && context.$message && context.$message.success(msg)
}

export const showInfo = (msg) => {
  context && context.$message && context.$message.info(msg)
}

export const showErr = (msg) => {
  context && context.$message && context.$message.error(msg)
  console.error(msg)
}

export default {
  getShortMsg: (msg, maxLen) => {
    if (msg && maxLen && msg.length > maxLen) {
      return `${msg.substr(0, maxLen)}...`
    }
    return msg;
  }
}
